import Joi from "joi";

import {
  PHONE_MAX_LENGTH,
  PHONE_MIN_LENGTH,
} from "../models/constants/model-constants";

/**
 * Phone: only length rules (trimmed length 8–15). No digit/format checks.
 */
export const phoneJoiString = Joi.string()
  .trim()
  .min(PHONE_MIN_LENGTH)
  .max(PHONE_MAX_LENGTH)
  .messages({
    "string.min": `Phone number must be at least ${PHONE_MIN_LENGTH} characters`,
    "string.max": `Phone number must be at most ${PHONE_MAX_LENGTH} characters`,
  });
